import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

// Selectors, performing common selection tasks for this slice.
export const selectUserPayGroups = ({ careWorkers }: RootState) => careWorkers.userPayGroups.rows;
export const selectUserPayGroupByID = createSelector(
  [selectUserPayGroups, (_: RootState, id?: number) => id],
  (rows, id) => rows.find(({ id: rowId }) => id === rowId),
);
